module.exports = __webpack_public_path__ + "img/1-2.41591621.svg";